
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/database/[id]",
      function () {
        return require("private-next-pages/database/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/database/[id]"])
      });
    }
  